import { ItemTypeEntity } from '@entities/ItemType/Types';
import { ItemTypeInfoMobile } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/ItemTypesListMobile/ItemTypeInfoMobile/ItemTypeInfoMobile';
import css from './ItemTypesListMobile.module.css';
import {
    StepNumberEnum,
    StepNumberType,
} from '@modules/Steps/Shared/Enums/StepNumberEnum';
import { CheckedItemInfoMobile } from '@modules/Steps/Components/Step3/Step3MobileContent/FragmentInfoMobileStep3/CheckedItemInfoMobile/CheckedItemInfoMobile';
import { CheckedItem } from '@modules/Steps/Shared/Interfaces/CheckedItem';

interface ItemTypesListMobileProps {
    itemTypes: ItemTypeEntity[];
    stepNumber?: StepNumberType;
}

export const ItemTypesListMobile: React.FC<ItemTypesListMobileProps> = ({
    itemTypes,
    stepNumber = StepNumberEnum.STEP2,
}) => {
    const allItems: CheckedItem[] =
        stepNumber === StepNumberEnum.STEP3
            ? itemTypes.flatMap(itemType =>
                  (itemType.items || []).filter(Boolean).map(item => ({
                      item,
                      isLabour: itemType.labor,
                  }))
              )
            : [];

    return (
        <div className={css.itemTypesListContainer}>
            {stepNumber === StepNumberEnum.STEP3
                ? allItems.map(item => (
                      <CheckedItemInfoMobile item={item} key={item.item.uuid} />
                  ))
                : itemTypes.map(itemType => (
                      <ItemTypeInfoMobile
                          itemType={itemType}
                          key={itemType.uuid}
                      />
                  ))}
        </div>
    );
};
